import 'regenerator-runtime/runtime'

import React, { useEffect } from 'react'

import { createRoot } from 'react-dom/client'

import { JSX as StencilJSX } from 'xplor-component-library/dist/types'
import { defineCustomElements } from 'xplor-component-library/loader'

import { AuthProvider } from '~/contexts/AuthContext'
import App from '~/pages/App'

import WithRequest from './helper/WithRequest'
import './walkme-loader'

declare global {
  interface JSX {
    IntrinsicElements: StencilJSX.IntrinsicElements
  }
}
const Root = () => {
  useEffect(() => {
    // Initialize analytics after the component mounts to avoid TDZ issues with module federation
    import('./helper/analytics/Analytics').then((Analytics) => {
      Analytics.initialize()
    })
  }, [])
  return (
    <AuthProvider>
      <WithRequest>
        <App />
      </WithRequest>
    </AuthProvider>
  )
}

const container = document.getElementById('root')

if (!container) {
  throw new Error("Root container element with id 'root' not found")
}
const root = createRoot(container)
root.render(<Root />)
defineCustomElements(window)
